import React from "react";
var __jsx = React.createElement;
import whatsappIcon from "./whatsapp.svg";
import { useTranslation } from "@i18n";
var OilContactSection = function OilContactSection(_ref) {
  var contact = _ref.contact;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("section", {
    className: "relative mx-4 mb-3 rounded-2xl overflow-hidden md:max-w-[1200px] md:mx-auto h-[350px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: contact.image_mobile,
    alt: "Contact background",
    className: "absolute inset-0 w-full h-full object-cover md:hidden",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("img", {
    src: contact.image,
    alt: "Contact background",
    className: "absolute inset-0 w-full h-full object-cover hidden md:block",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative flex flex-col items-center justify-center gap-4 px-6 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-16 h-16 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 rounded-full bg-[#FFE4D6] opacity-60"
  }), /*#__PURE__*/React.createElement("img", {
    src: contact.icon,
    alt: "Contact icon",
    className: "relative w-10 h-10 object-contain"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-1 text-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "block text-2xl md:text-3xl font-bold  m-0 pb-4"
  }, contact.title), /*#__PURE__*/React.createElement("p", {
    className: "text-lg font-bold m-0"
  }, contact.subtitle), /*#__PURE__*/React.createElement("a", {
    dir: "ltr",
    href: "tel:".concat(contact.phone),
    className: "text-lg font-bold text-primary-new mt-1 no-underline hover:underline"
  }, contact.phone)), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      window.open("https://wa.me/".concat(contact.whatsapp), "_blank");
    },
    className: "flex items-center font-bold gap-2 border border-soild border-primary-new text-primary-new rounded-lg px-10 py-3  bg-transparent"
  }, /*#__PURE__*/React.createElement("img", {
    src: whatsappIcon,
    alt: "WhatsApp",
    className: "w-6 h-6"
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, " ", t("contact_via_whatsapp", {
    ns: "web_common"
  })))));
};
export default OilContactSection;